import { render } from "./ModalAddEditCustomer.vue?vue&type=template&id=4f05c0bc"
import script from "./ModalAddEditCustomer.vue?vue&type=script&lang=js"
export * from "./ModalAddEditCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__